// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nlabel[data-v-7a96a24f] {\n    display: block !important;\n    margin: 0 0 .28571429rem 0 !important;\n    color: rgba(0,0,0,.87) !important;\n    font-size: .92857143em !important;\n    font-weight: 700 !important;\n    text-transform: none !important;\n}\n.invalid-feedback[data-v-7a96a24f] {\n    margin-left: 1px;\n    color: #D63301;\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
